export const TOGGLE_FK_GROUP_DIALOG = 'TOGGLE_FK_GROUP_DIALOG';
export const SET_FK_GROUP_ID = 'SET_FK_GROUP_ID';
export const TOGGLE_FK_USER_DIALOG = 'TOGGLE_FK_USER_DIALOG';
export const SET_FK_USER_ID = 'SET_FK_USER_ID';
export const TOGGLE_FK_GROUP_DETAILS_DIALOG = 'TOGGLE_FK_GROUP_DETAILS_DIALOG';
export const TOGGLE_FK_USER_DETAILS_DIALOG = 'TOGGLE_FK_USER_DETAILS_DIALOG';
